module.exports = __webpack_public_path__ + "static/media/3_r_samovar_88.7_84.17.46aa15e8.png";